var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 12H23.75V5.25C23.75 4.65326 23.5129 4.08097 23.091 3.65901C22.669 3.23705 22.0967 3 21.5 3H14.75C14.1533 3 13.581 3.23705 13.159 3.65901C12.7371 4.08097 12.5 4.65326 12.5 5.25V12H5.75C5.15326 12 4.58097 12.2371 4.15901 12.659C3.73705 13.081 3.5 13.6533 3.5 14.25V21C3.5 21.5967 3.73705 22.169 4.15901 22.591C4.58097 23.0129 5.15326 23.25 5.75 23.25H12.5V30C12.5 30.5967 12.7371 31.169 13.159 31.591C13.581 32.0129 14.1533 32.25 14.75 32.25H21.5C22.0967 32.25 22.669 32.0129 23.091 31.591C23.5129 31.169 23.75 30.5967 23.75 30V23.25H30.5C31.0967 23.25 31.669 23.0129 32.091 22.591C32.5129 22.169 32.75 21.5967 32.75 21V14.25C32.75 13.6533 32.5129 13.081 32.091 12.659C31.669 12.2371 31.0967 12 30.5 12ZM30.5 21H22.625C22.3266 21 22.0405 21.1185 21.8295 21.3295C21.6185 21.5405 21.5 21.8266 21.5 22.125V30H14.75V22.125C14.75 21.8266 14.6315 21.5405 14.4205 21.3295C14.2095 21.1185 13.9234 21 13.625 21H5.75V14.25H13.625C13.9234 14.25 14.2095 14.1315 14.4205 13.9205C14.6315 13.7095 14.75 13.4234 14.75 13.125V5.25H21.5V13.125C21.5 13.4234 21.6185 13.7095 21.8295 13.9205C22.0405 14.1315 22.3266 14.25 22.625 14.25H30.5V21Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.b3e5545cf5ecba8b6d09f45e8b1c6467.svg";
export { ForwardRef as ReactComponent };